'use client';

import React, { useState, useEffect } from 'react';

interface MockLoadingProps {
    isActive: boolean;
}

export function MockLoading({ isActive }: MockLoadingProps) {
    const [status, setStatus] = useState('Initializing...');
    const statuses = [
        "Analyzing requirements...",
        "Structuring layout...",
        "Writing compelling copy...",
        "Generating color palette...",
        "Finalizing design...",
    ];

    useEffect(() => {
        if (isActive) {
            let i = 0;
            const interval = setInterval(() => {
                setStatus(statuses[i % statuses.length]);
                i++;
            }, 400); // Fast updates
            return () => clearInterval(interval);
        }
    }, [isActive]);

    return (
        <div className="w-full h-full flex flex-col items-center justify-center bg-white">
            <div className="relative">
                {/* Spinner */}
                <div className="w-24 h-24 rounded-full border-4 border-indigo-100 border-t-indigo-600 animate-spin"></div>
                {/* Icon Center */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <svg className="w-8 h-8 text-indigo-600 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                </div>
            </div>
            <h3 className="mt-8 text-xl font-semibold text-gray-900">Creating your site</h3>
            <p className="mt-2 text-gray-500 animate-pulse">{status}</p>
        </div>
    );
}
